import { Image, Container, Title, Text, Button, SimpleGrid } from '@mantine/core';
import notFound from '../assets/image/notFound.svg';
import classes from './NotFoundImage.module.css';
import { useNavigate } from 'react-router-dom';

export function NotFoundImage({ error }: any) {
  console.log("notfound error main log", error);
  const navigate = useNavigate();

  // Extract error code if it exists
  // Add this helper to extract status from string if necessary
  const extractStatusCodeFromString = (str: string): number | undefined => {
    const match = str.match(/Status:\s*(\d{3})/);
    return match ? parseInt(match[1], 10) : undefined;
  };

  const errorCode =
    typeof error === 'object' ? error?.status || error?.statusCode || error?.code : typeof error === 'string' ? extractStatusCodeFromString(error) : undefined;


  // Define user-friendly messages based on error codes
  const getFriendlyErrorMessage = () => {
    if (!error) return 'Something went wrong';

    // Handle object errors
    if (typeof error === 'object') {
      // Handle specific error codes
      console.log(errorCode, 'bdcqjhlrwkjnr3vqhLFSKDBHQURJFLksbvquef jlhrbphwj')
      switch (errorCode) {
        case 401:
          return 'You are unauthorized to access this page. Please log in again.';
        case 403:
          return 'You do not have permission to access this resource.';
        case 404:
          return 'The requested resource could not be found.';
        case 500:
          return 'Server error occurred. Please try again later.';
        default:
          // Return custom message if available, otherwise generic message
          return error.error || error.message || 'An unexpected error occurred.';
      }
    }

    // Handle string errors
    return error;
  };

  // Get appropriate title based on error
  const getErrorTitle = () => {
    if (errorCode === 401 || errorCode === 403) return 'Access Denied';
    if (errorCode === 404) return 'Page Not Found';
    return 'Something is not right...';
  };

  return (
    <Container className={classes.container}>
      <SimpleGrid cols={{ base: 1, sm: 1 }}>
        <Image src={notFound} className={classes.desktopImage} />
        <div>
          <Title className={classes.title}>{getErrorTitle()}</Title>
          <Text c="dimmed" size="lg" ta="center">
            {errorCode === 404 ?
              'Page you are trying to open does not exist. You may have mistyped the address, or the page has been moved to another URL.' :
              'We encountered an issue while processing your request.'}
          </Text>
          <Text c="red" size="lg" ta="center">
            {getFriendlyErrorMessage()}
          </Text>
          <Button variant="outline" size="md" mt="xl" className={classes.control} onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </div>
      </SimpleGrid>
    </Container>
  );
}